import React from "react";
import Symptoms from "./Symtoms";
import Packages from "./Packages";
import LabList from "./LabList";
import OfferForYou from "../../component/HomePage/OfferForYou";
export default function LabPage() {
  return (
    <div className="mt-5">

      {/* FULL WIDTH - SYMPTOMS */}
      <div className="relative overflow-x-visible px-4">
        <Symptoms />
      </div>

      {/* FULL WIDTH - LAB LIST */}
      <div className="relative overflow-x-visible px-4">
        <LabList />
      </div>
       <div className="relative overflow-x-visible px-4">
        <OfferForYou />
      </div>

      {/* ✅ FULL WIDTH - PACKAGES */}
      <div className="relative overflow-x-visible px-4">
        <Packages />
      </div>

    </div>
  );
}